// extracted by mini-css-extract-plugin
export var button = "HeaderTabs-module--button---y7iV";
export var component = "HeaderTabs-module--component--cqGQ2";
export var isActive = "HeaderTabs-module--isActive--yyXbO";
export var list = "HeaderTabs-module--list--eVW05";